import { Stack } from '@mui/material';

export default function CarouselOverlay({ children }) {
    return (
        <Stack direction="column" justifyContent="space-between" alignItems="stretch" sx={{ width: 1, height: 1, position: 'absolute', top: 0, zIndex: 1, pointerEvents: 'none' }}>
            {children}
        </Stack>
    );
}
